import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, renderList as _renderList, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "flex justify-between" };
const _hoisted_2 = { class: "flex space-x-4" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("p", { class: "font-semibold mb-4" }, " Characterisation of sign/symptom ", -1);
const _hoisted_4 = { class: "flex flex-wrap" };
const _hoisted_5 = {
    key: 0,
    class: "w-full md:w-1/2 space-y-4"
};
const _hoisted_6 = {
    key: 1,
    class: "w-full mt-6 md:w-1/2 md:mt-0"
};
const _hoisted_7 = { class: "flex" };
const _hoisted_8 = {
    key: 0,
    class: "w-1/2"
};
const _hoisted_9 = { class: "space-y-4" };
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("p", { class: "font-semibold text-gray-900" }, " Previous episode(s) ", -1);
const _hoisted_11 = {
    key: 1,
    class: "w-1/2"
};
const _hoisted_12 = { class: "space-y-4" };
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("p", { class: "font-semibold text-gray-900" }, " Anatomical location(s) ", -1);
const _hoisted_14 = { class: "font-semibold text-gray-900 text-sm mb-2" };
const _hoisted_15 = {
    key: 1,
    class: "text-sm"
};
const _hoisted_16 = { class: "flex" };
const _hoisted_17 = { class: "w-full space-y-6 md:space-y-0 md:flex md:space-x-6" };
import dayjs from 'dayjs';
import { computed } from 'vue';
import { parseDuration } from '../utils';
import { BlockDisplayTitle, BlockDisplayDetail, BlockValueList } from './_display';
import { BlockDivider, BlockDetailCard, BlockPanel } from './_layout';
export default /*#__PURE__*/ _defineComponent({
    __name: 'PastPresentingComplaint',
    props: {
        presentingComplaint: {
            type: Object,
            required: true
        }
    },
    setup(__props) {
        const props = __props;
        const getPastItem = (name) => props.presentingComplaint.data.items[0].items.find(item => item.name?.value === name);
        const hasSignsOrSymptoms = computed(() => getPastItem('Description')?.value?.value
            || getPastItem('Onset type')?.value?.value
            || getPastItem('Severity category')?.value?.value
            || getPastItem('Severity rating')?.value?.magnitude
            || getPastItem('Character')?.value?.value
            || getPastItem('Progression')?.value?.value
            || getPastItem('Pattern')?.value?.value
            || getPastItem('Impact')?.value?.value
            || getPastItem('Episodicity')?.value?.value);
        const hasPreviousEpisodes = computed(() => getPastItem('Occurrence')?.value?.value
            || getPastItem('Number of previous episodes')?.value?.magnitude
            || getPastItem('Description of previous episodes')?.value?.value);
        const hasAnatomicalLocations = computed(() => getPastItem('Anatomical location'));
        const anatomicalLocationsContainMoreThanBodySiteName = computed(() => props.presentingComplaint
            .data
            .items[0]
            .items
            .filter(item => item.name?.value === 'Anatomical location')
            .some(anatomicalLocation => anatomicalLocation.items.some(item => item.name?.value === 'Laterality')
            || anatomicalLocation.items.some(item => item.name?.value === 'Aspect')
            || anatomicalLocation.items.some(item => item.name?.value === 'Anatomical Line')));
        const bodySiteNames = computed(() => props.presentingComplaint
            .data
            .items[0]
            .items
            .filter(item => item.name?.value === 'Anatomical location')
            .flatMap(anatomicalLocation => anatomicalLocation.items)
            .map(anatomicalLocation => anatomicalLocation?.value?.value)
            .filter(value => !!value)
            .join(', '));
        const hasPrecipitatingFactor = computed(() => !!props.presentingComplaint.data.items[0].items.filter(item => item.name?.value === 'Precipitating factor').length);
        const hasResolvingFactor = computed(() => !!props.presentingComplaint.data.items[0].items.filter(item => item.name?.value === 'Resolving factor').length);
        const hasModifyingFactor = computed(() => !!props.presentingComplaint.data.items[0].items.filter(item => item.name?.value === 'Modifying factor').length);
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(BlockPanel), { class: "p-6" }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createVNode(_unref(BlockDisplayTitle), {
                            title: getPastItem('Symptom/Sign name').value.value
                        }, null, 8, ["title"]),
                        _createElementVNode("div", _hoisted_2, [
                            (!!getPastItem('Duration')?.value?.value)
                                ? (_openBlock(), _createBlock(_unref(BlockDisplayDetail), {
                                    key: 0,
                                    label: "Duration",
                                    value: _unref(parseDuration)(getPastItem('Duration').value.value),
                                    muted: ""
                                }, null, 8, ["value"]))
                                : _createCommentVNode("", true),
                            (!!getPastItem('Episode onset')?.value?.value)
                                ? (_openBlock(), _createBlock(_unref(BlockDisplayDetail), {
                                    key: 1,
                                    label: "Episode Onset",
                                    value: _unref(dayjs)(getPastItem('Episode onset').value.value).format('hh:mm a DD/MM/YYYY'),
                                    muted: ""
                                }, null, 8, ["value"]))
                                : _createCommentVNode("", true),
                            (!!getPastItem('Episode resolution')?.value?.value)
                                ? (_openBlock(), _createBlock(_unref(BlockDisplayDetail), {
                                    key: 2,
                                    label: "Episode Resolution",
                                    value: _unref(dayjs)(getPastItem('Episode resolution').value.value).format('hh:mm a DD/MM/YYYY'),
                                    muted: ""
                                }, null, 8, ["value"]))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    (_unref(hasSignsOrSymptoms) || !!getPastItem('Overall Comment')?.value?.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createVNode(_unref(BlockDivider)),
                            _createElementVNode("div", null, [
                                _hoisted_3,
                                _createElementVNode("div", _hoisted_4, [
                                    (_unref(hasSignsOrSymptoms))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                            _createVNode(_unref(BlockValueList), {
                                                items: [
                                                    { key: 'Description', value: getPastItem('Description')?.value?.value },
                                                    { key: 'Onset type', value: getPastItem('Onset type')?.value?.value }
                                                ]
                                            }, null, 8, ["items"]),
                                            _createVNode(_unref(BlockValueList), {
                                                items: [
                                                    { key: 'Severity Category', value: getPastItem('Severity category')?.value?.value },
                                                    { key: 'Severity rating', value: getPastItem('Severity rating')?.value?.magnitude ? `${getPastItem('Severity rating').value.magnitude} / 10` : null },
                                                ]
                                            }, null, 8, ["items"]),
                                            _createVNode(_unref(BlockValueList), {
                                                items: [
                                                    { key: 'Character', value: getPastItem('Character')?.value?.value },
                                                    { key: 'Progression', value: getPastItem('Progression')?.value?.value },
                                                ]
                                            }, null, 8, ["items"]),
                                            _createVNode(_unref(BlockValueList), {
                                                items: [
                                                    { key: 'Pattern', value: getPastItem('Pattern')?.value?.value },
                                                    { key: 'Impact', value: getPastItem('Impact')?.value?.value }
                                                ]
                                            }, null, 8, ["items"]),
                                            _createVNode(_unref(BlockValueList), {
                                                items: [
                                                    { key: 'Episodicity', value: getPastItem('Episodicity')?.value?.value }
                                                ]
                                            }, null, 8, ["items"])
                                        ]))
                                        : _createCommentVNode("", true),
                                    (!!getPastItem('Overall Comment')?.value?.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                            _createVNode(_unref(BlockDisplayDetail), {
                                                label: "Overall comment",
                                                value: getPastItem('Overall Comment').value.value
                                            }, null, 8, ["value"])
                                        ]))
                                        : _createCommentVNode("", true)
                                ])
                            ])
                        ], 64))
                        : _createCommentVNode("", true),
                    (_unref(hasPreviousEpisodes) || _unref(hasAnatomicalLocations))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createVNode(_unref(BlockDivider)),
                            _createElementVNode("div", _hoisted_7, [
                                (_unref(hasPreviousEpisodes))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                        _createElementVNode("div", _hoisted_9, [
                                            _hoisted_10,
                                            (!!getPastItem('Occurrence')?.value?.value)
                                                ? (_openBlock(), _createBlock(_unref(BlockDisplayDetail), {
                                                    key: 0,
                                                    label: "Occurrence",
                                                    value: getPastItem('Occurrence').value.value
                                                }, null, 8, ["value"]))
                                                : _createCommentVNode("", true),
                                            (!!getPastItem('Number of previous episodes')?.value?.magnitude)
                                                ? (_openBlock(), _createBlock(_unref(BlockDisplayDetail), {
                                                    key: 1,
                                                    label: "Number of previous episodes",
                                                    value: getPastItem('Number of previous episodes').value.magnitude
                                                }, null, 8, ["value"]))
                                                : _createCommentVNode("", true),
                                            (!!getPastItem('Description of previous episodes')?.value?.value)
                                                ? (_openBlock(), _createBlock(_unref(BlockDisplayDetail), {
                                                    key: 2,
                                                    label: "Description of previous episodes",
                                                    value: getPastItem('Description of previous episodes').value.value
                                                }, null, 8, ["value"]))
                                                : _createCommentVNode("", true)
                                        ])
                                    ]))
                                    : _createCommentVNode("", true),
                                (_unref(hasAnatomicalLocations))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                        _createElementVNode("div", _hoisted_12, [
                                            _hoisted_13,
                                            (_unref(anatomicalLocationsContainMoreThanBodySiteName))
                                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.presentingComplaint.data.items[0].items.filter(item => item.name?.value === 'Anatomical location'), (anatomicalLocation, anatomicalLocationIndex) => {
                                                    return (_openBlock(), _createElementBlock("div", { key: anatomicalLocationIndex }, [
                                                        _createElementVNode("p", _hoisted_14, _toDisplayString(anatomicalLocation.items.find(item => item.name?.value === 'Body site name')?.value?.value), 1),
                                                        _createVNode(_unref(BlockValueList), {
                                                            items: [
                                                                { key: 'Laterality', value: anatomicalLocation.items.find(item => item.name?.value === 'Laterality')?.value?.value },
                                                                { key: 'Aspect', value: anatomicalLocation.items.filter(item => item.name?.value === 'Aspect').map(aspect => aspect?.value?.value).join(', ') },
                                                                { key: 'Anatomical Line', value: anatomicalLocation.items.find(item => item.name?.value === 'Anatomical Line')?.value?.value },
                                                            ]
                                                        }, null, 8, ["items"])
                                                    ]));
                                                }), 128))
                                                : (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_unref(bodySiteNames)), 1))
                                        ])
                                    ]))
                                    : _createCommentVNode("", true)
                            ])
                        ], 64))
                        : _createCommentVNode("", true),
                    (!!__props.presentingComplaint.data.items[0].items.filter(item => item.name?.value === 'Symptom/Sign').length)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createVNode(_unref(BlockDivider)),
                            _createElementVNode("div", _hoisted_16, [
                                _createVNode(_unref(BlockDetailCard), {
                                    class: "w-full border-gray-300",
                                    label: "Associated symptoms/sign(s)"
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", {
                                            class: _normalizeClass(["grid gap-6", {
                                                    'grid-cols-2': __props.presentingComplaint.data.items[0].items.filter(item => item.name?.value === 'Symptom/Sign').length <= 2,
                                                    'grid-cols-3': __props.presentingComplaint.data.items[0].items.filter(item => item.name?.value === 'Symptom/Sign').length > 2
                                                }])
                                        }, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.presentingComplaint.data.items[0].items.filter(item => item.name?.value === 'Symptom/Sign'), (associatedSignSymptom, associatedSignIndex) => {
                                                return (_openBlock(), _createBlock(_unref(BlockDisplayDetail), {
                                                    key: associatedSignIndex,
                                                    spaced: "",
                                                    label: associatedSignSymptom.items.find(item => item.name?.value === 'Symptom/Sign name')?.value?.value,
                                                    subtitle: associatedSignSymptom.items.find(item => item.name?.value === 'Anatomical location')?.items?.find(item => item.name?.value === 'Body site name')?.value?.value,
                                                    value: associatedSignSymptom.items.find(item => item.name?.value === 'Comment')?.value?.value
                                                }, null, 8, ["label", "subtitle", "value"]));
                                            }), 128))
                                        ], 2)
                                    ]),
                                    _: 1
                                })
                            ])
                        ], 64))
                        : _createCommentVNode("", true),
                    (_unref(hasPrecipitatingFactor) || _unref(hasModifyingFactor) || _unref(hasResolvingFactor))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                            _createVNode(_unref(BlockDivider)),
                            _createElementVNode("div", _hoisted_17, [
                                (_unref(hasPrecipitatingFactor))
                                    ? (_openBlock(), _createBlock(_unref(BlockDetailCard), {
                                        key: 0,
                                        class: "flex-1 border-blue-400",
                                        label: "Precipitating factor(s)"
                                    }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("div", {
                                                class: _normalizeClass(["gap-y-6 grid", {
                                                        'md:grid-cols-2 md:gap-x-6': !_unref(hasModifyingFactor) && !_unref(hasResolvingFactor),
                                                    }])
                                            }, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.presentingComplaint.data.items[0].items.filter(item => item.name?.value === 'Precipitating factor'), (associatedSignSymptom, associatedSignIndex) => {
                                                    return (_openBlock(), _createBlock(_unref(BlockDisplayDetail), {
                                                        key: associatedSignIndex,
                                                        spaced: "",
                                                        label: associatedSignSymptom.items.find(item => item.name?.value === 'Precipitating factor')?.value?.value,
                                                        value: associatedSignSymptom.items.find(item => item.name?.value === 'Description')?.value?.value
                                                    }, null, 8, ["label", "value"]));
                                                }), 128))
                                            ], 2)
                                        ]),
                                        _: 1
                                    }))
                                    : _createCommentVNode("", true),
                                (_unref(hasModifyingFactor))
                                    ? (_openBlock(), _createBlock(_unref(BlockDetailCard), {
                                        key: 1,
                                        class: "flex-1 border-yellow-400",
                                        label: "Modifying factor(s)"
                                    }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("div", {
                                                class: _normalizeClass(["gap-y-6 grid", {
                                                        'md:grid-cols-2 md:gap-x-6': !_unref(hasPrecipitatingFactor) && !_unref(hasResolvingFactor),
                                                    }])
                                            }, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.presentingComplaint.data.items[0].items.filter(item => item.name?.value === 'Modifying factor'), (associatedSignSymptom, associatedSignIndex) => {
                                                    return (_openBlock(), _createBlock(_unref(BlockDisplayDetail), {
                                                        key: associatedSignIndex,
                                                        spaced: "",
                                                        label: associatedSignSymptom.items.find(item => item.name?.value === 'Modifying factor')?.value?.value,
                                                        subtitle: associatedSignSymptom.items.find(item => item.name?.value === 'Effect')?.value?.value,
                                                        value: associatedSignSymptom.items.find(item => item.name?.value === 'Description')?.value?.value
                                                    }, null, 8, ["label", "subtitle", "value"]));
                                                }), 128))
                                            ], 2)
                                        ]),
                                        _: 1
                                    }))
                                    : _createCommentVNode("", true),
                                (_unref(hasResolvingFactor))
                                    ? (_openBlock(), _createBlock(_unref(BlockDetailCard), {
                                        key: 2,
                                        class: "flex-1 border-green-400",
                                        label: "Resolving factor(s)"
                                    }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("div", {
                                                class: _normalizeClass(["gap-y-6 grid", {
                                                        'md:grid-cols-2 md:gap-x-6': !_unref(hasPrecipitatingFactor) && !_unref(hasModifyingFactor),
                                                    }])
                                            }, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.presentingComplaint.data.items[0].items.filter(item => item.name?.value === 'Resolving factor'), (associatedSignSymptom, associatedSignIndex) => {
                                                    return (_openBlock(), _createBlock(_unref(BlockDisplayDetail), {
                                                        key: associatedSignIndex,
                                                        spaced: "",
                                                        label: associatedSignSymptom.items.find(item => item.name?.value === 'Resolving factor')?.value?.value,
                                                        value: associatedSignSymptom.items.find(item => item.name?.value === 'Description')?.value?.value
                                                    }, null, 8, ["label", "value"]));
                                                }), 128))
                                            ], 2)
                                        ]),
                                        _: 1
                                    }))
                                    : _createCommentVNode("", true)
                            ])
                        ], 64))
                        : _createCommentVNode("", true)
                ]),
                _: 1
            }));
        };
    }
});
